// app/(auth)/login/page.tsx

import LoginForm from "../../../components/auth/LoginForm";
import { ROLES } from "../../../lib/constants";

export default function UserLoginPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-dark-primary p-4 relative">
      {/* Ambient background accents */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -top-20 -left-20 w-72 h-72 rounded-full bg-golden-accent/10 blur-3xl" />
        <div className="absolute -bottom-24 -right-20 w-80 h-80 rounded-full bg-golden-accent/5 blur-3xl" />
      </div>

      <div className="relative w-full max-w-5xl flex rounded-2xl ring-1 ring-dark-border/60 shadow-2xl overflow-hidden bg-dark-secondary/70 backdrop-blur-xl">
        {/* Left Panel: Login Form */}
        <div className="w-full md:w-1/2 flex flex-col justify-center p-8 md:p-12">
          <div className="flex items-center mb-8">
            {/* Logo from public assets to ensure visibility */}
            <img src="/G1.svg" alt="Logo" className="w-10 h-10 mr-3" />
            <span className="text-2xl font-bold tracking-tight text-text-primary">Livelong Wealth</span>
          </div>
          <h1 className="text-3xl md:text-4xl font-extrabold text-text-primary mb-2">Sign In</h1>
          <p className="text-text-secondary mb-8">Welcome back! Please login to your account.</p>
          <LoginForm role={ROLES.USER} />
        </div>
        {/* Right Panel: Welcome Message */}
        <div className="hidden md:flex flex-col items-center justify-center w-1/2 bg-gradient-to-br from-dark-tertiary to-dark-secondary p-10 text-text-primary relative">
          {/* subtle concentric accent */}
          <div className="absolute inset-0 flex items-center justify-center opacity-30">
            <div className="w-72 h-72 rounded-full border border-dark-border/60" />
            <div className="absolute w-44 h-44 rounded-full border border-dark-border/50" />
          </div>

          <div className="relative flex flex-col items-center">
            <div className="bg-dark-border/40 rounded-2xl p-6 mb-6 ring-1 ring-dark-border">
              <img src="/G1.svg" alt="Welcome Icon" className="w-16 h-16" />
            </div>
            <h2 className="text-2xl font-bold mb-2 text-center">Welcome to SuBs</h2>
            <p className="text-center text-base font-medium text-text-secondary max-w-sm">
              Manage and grow your subscription communities across Telegram, Discord, and more.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
